import { AlertList } from "src/components/AlertV2/AlertList.tsx";
import type { ReactNode } from "react";

export const AccountingPostingMarketplaceError = ({
  errors,
  title,
}: {
  title: ReactNode;
  errors: string[];
}) => {
  return (
    <AlertList
      items={errors.map((error) => ({
        title: error,
      }))}
      title={title}
    />
  );
};
